import { render, staticRenderFns } from "./CheckSellable.vue?vue&type=template&id=6c070898&scoped=true&"
import script from "./CheckSellable.vue?vue&type=script&lang=js&"
export * from "./CheckSellable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c070898",
  null
  
)

export default component.exports